import { Link } from 'react-router-dom';
import css from './ForWhoSection.module.css';
import selfBuildersImg from '../../../../assets/Self-builder.png';
import buildersImg from '../../../../assets/Builders-and-Construction.png';
import selfBuildersIcon from '../../../../assets/Self-builders-house-logo.svg';
import buildersIcon from '../../../../assets/builders-construction-logo.svg';

const ArrowRight = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ForWhoSection = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.cardsRow}>

        {/* Left Card — Self Builders */}
        <div className={css.card} style={{ backgroundImage: `url(${selfBuildersImg})` }}>
          <div className={css.overlay} />
          <div className={css.cardContent}>
            <div className={css.iconWrap}><img src={selfBuildersIcon} alt="Self Builders" className={css.cardIcon} /></div>
            <h3 className={css.cardTitle}>
              For Self-Builders, Homeowners &amp; Developers
            </h3>
            <p className={css.cardDesc}>
              Submitted Planning? Start preparing your project brief, meet your supply chain and understand your costs.
            </p>
            <Link to="/startyourproject" className={css.ctaButton}>
              Start Your Project <ArrowRight />
            </Link>
          </div>
        </div>

        {/* Right Card — Builders & Construction */}
        <div className={css.card} style={{ backgroundImage: `url(${buildersImg})` }}>
          <div className={css.overlay} />
          <div className={css.cardContent}>
            <div className={css.iconWrap}><img src={buildersIcon} alt="Builders & Construction" className={css.cardIcon} /></div>
            <h3 className={css.cardTitle}>
              For Builders &amp; Construction Services
            </h3>
            <p className={css.cardDesc}>
              Get early access to self builders and developers, automate outreach and win more work.
            </p>
            <Link to="/leadflow" className={css.ctaButton}>
              Get More Leads <ArrowRight />
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ForWhoSection;
